import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-409988d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggle-container" }
const _hoisted_2 = { class: "toggle-content" }
const _hoisted_3 = { class: "start" }

import { RoleEnum } from "@/generated/graphql";
import useRoles from "@/hooks/useRole";
import { IonText, IonToggle, IonLabel, IonSpinner, IonIcon, IonImg } from "@ionic/vue";
import { computed, ref } from "vue";


const __default__ = {
  name: "BaseToggle",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: {},
    value: { type: Boolean },
    content: {},
    loading: { type: Boolean },
    class: {},
    img: {},
    description: {},
    fontLato: { type: Boolean }
  },
  emits: ["change", "update:value"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { role } = useRoles();




const onChange = (value: boolean) => {
  emits("change", value);
  emits("update:value", value);
};

const inputValue = computed({
  get() {
    return props.value;
  },
  set(updatedValue: boolean) {
    emits("update:value", updatedValue);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-toggle-container", { 'base-toggle-container--loading': _ctx.loading, 'base-toggle-trainer': (_unref(role) === _unref(RoleEnum).Trainer || _unref(role) === _unref(RoleEnum).User) }])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_unref(IonSpinner), {
          key: 0,
          name: "lines",
          class: "spinner"
        }))
      : _createCommentVNode("", true),
    (_ctx.label)
      ? (_openBlock(), _createBlock(_unref(IonLabel), {
          key: 1,
          class: "label"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.img)
            ? (_openBlock(), _createBlock(_unref(IonImg), {
                key: 0,
                src: `assets/icon/${_ctx.img}`
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonText), {
            class: _normalizeClass({ 'font-lato': _ctx.fontLato })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.content), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode(_unref(IonToggle), {
          onIonChange: _cache[0] || (_cache[0] = ($event: any) => (onChange($event.target.checked))),
          checked: inputValue.value
        }, null, 8, ["checked"])
      ]),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['description',  { 'active-dec': inputValue.value }])
          }, _toDisplayString(_ctx.description), 3))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})